import React from "react";
import { Redirect } from "react-router-dom";
import {
  LOGIN_ROUTE,
  MAIN_MENU_ROUTE,
} from "../../containers/routes/RoutesConstants";
import { useAuthContext } from "../../context/Auth/AuthContainer";

const NotFound = () => {
  const { checkAuthentication } = useAuthContext();
  return (
    <React.Fragment>
      {checkAuthentication() ? (
        <Redirect to={MAIN_MENU_ROUTE} />
      ) : (
        <Redirect to={LOGIN_ROUTE} />
      )}
    </React.Fragment>
  );
};

export default NotFound;
